import { render, staticRenderFns } from "./Gerais.vue?vue&type=template&id=10478b0e"
import script from "./Gerais.vue?vue&type=script&lang=js"
export * from "./Gerais.vue?vue&type=script&lang=js"
import style0 from "./Gerais.vue?vue&type=style&index=0&id=10478b0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports